import React, { useState, useEffect } from 'react';
import { useLoaderData, Link, useFetcher } from 'react-router-dom';
import { InsuranceCompanyData, ProviderData } from '@/common/types';
import { Table, Container } from 'react-bootstrap';
import { Pencil, Eye, Trash } from 'react-bootstrap-icons';
import Avatar from '@/common/components/Avatar.tsx';
import ProviderDeleteModal from '@/portal/routes/providers/components/ProviderDeleteModal.tsx';
import { useFlashMessage } from '@/common/contexts/FlashMessageContext';

const IndexPage: React.FC = () => {
  const { providers, insuranceCompanies } = useLoaderData() as {
    providers: ProviderData[];
    insuranceCompanies: InsuranceCompanyData[];
  };

  const [providerToDelete, setProviderToDelete] = useState<ProviderData | null>(
    null
  );

  const fetcher = useFetcher();
  const { setFlashMessage } = useFlashMessage();

  useEffect(() => {
    if (fetcher.data?.success && fetcher.data.flash) {
      setFlashMessage(fetcher.data.flash.message, fetcher.data.flash.type);
    }
  }, [fetcher.data, setFlashMessage]);

  return (
    <Container className="py-4">
      <div className="mb-3 text-start">
        <Link to="/portal/providers/new" className="btn btn-primary">
          New Provider
        </Link>
      </div>
      <Table striped hover borderless size="sm" responsive>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>Name</th>
            <th>Credentials</th>
            <th>States</th>
            <th>Insurance Companies</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {providers.map((provider) => (
            <tr key={provider.id}>
              <td>
                <Link
                  to={`/portal/providers/${provider.id}`}
                  className="me-3 text-decoration-none"
                  title="View"
                >
                  <Eye />
                </Link>
                <Link
                  to={`/portal/providers/${provider.id}/edit`}
                  className="me-3 text-decoration-none"
                  title="Edit"
                >
                  <Pencil />
                </Link>
              </td>
              <td>
                <Avatar
                  src={provider.avatarUrl}
                  alt={provider.firstName}
                  size={32}
                />
              </td>
              <td>
                {provider.firstName} {provider.lastName}
              </td>
              <td>
                {provider.credentials.map((c) => c.abbreviation).join(', ')}
              </td>
              <td>{provider.states.map((s) => s.code).join(', ')}</td>
              <td>
                {provider.insuranceCompanies.length}/{insuranceCompanies.length}
              </td>
              <td>
                <button
                  type="button"
                  className="btn btn-link p-0 border-0 text-danger"
                  onClick={() => setProviderToDelete(provider)}
                >
                  <Trash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <ProviderDeleteModal
        show={providerToDelete !== null}
        provider={providerToDelete}
        onCancel={() => setProviderToDelete(null)}
        fetcher={fetcher}
      />
    </Container>
  );
};

export default IndexPage;
